import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TRIGGERS_QUERY_KEY} from "../queryKeys";

type DeleteTriggerVariables = {id: number};

const deleteTrigger = async ({id}: DeleteTriggerVariables): Promise<boolean> => {
  const response = await axiosReachInstance.delete<boolean, AxiosResponse<boolean>>(`/triggers/${id}`);
  return response.data;
};

export const useDeleteTrigger = (
  options?: BaseMutationOptions<boolean, DeleteTriggerVariables>
): BaseUseMutationResult<boolean, DeleteTriggerVariables> => {
  return useBaseMutation<boolean, DeleteTriggerVariables>(deleteTrigger, {
    ...options,
    prefixKeysToReset: () => [[TRIGGERS_QUERY_KEY]],
  });
};
